"use strict";

import { Application } from "../../main/application.js";

export class Mouse {
    static enableMouseMoveFlag() {
        Application.main.renderer.plugins.interaction.moveWhenInside = true;
    }
    static disableMouseMoveFlag() {
        Application.main.renderer.plugins.interaction.moveWhenInside = false;
    }

    static registerGlobalEvent(type,event,options = false) {
        document.addEventListener(type,event,options);
    }
    static unregisterGlobalEvent(type,event,options = false) {
        document.removeEventListener(type,event,options);
    }

    static registerMouseScroll(event) {
        Mouse.registerGlobalEvent("wheel", event);
        Mouse.registerGlobalEvent("mousewheel", event);
    }
    static unregisterMouseScroll(event) {
        Mouse.unregisterGlobalEvent("wheel", event);
        Mouse.unregisterGlobalEvent("mousewheel", event);
    }
}